import { FileText, Trash2 } from 'lucide-react';
import { ProjectDocument } from '../../../types/project';
import { formatFileSize, formatFullDate, getFileExtension } from '../../../utils/formatters';

interface ProjectFileCardProps {
  document: ProjectDocument;
  onClick: () => void;
  onDelete: (e: React.MouseEvent) => void;
}

/**
 * ProjectFileCard - Card de arquivo/documento do projeto
 */
export const ProjectFileCard = ({
  document,
  onClick,
  onDelete
}: ProjectFileCardProps) => {
  return (
    <div
      onClick={onClick}
      className="
        flex items-center gap-4 p-4
        bg-[#1a1a1a] border border-[#333333] rounded-lg
        hover:border-[#F4CC04] cursor-pointer
        transition-colors group
      "
    >
      {/* File icon */}
      <div className="
        flex flex-col items-center justify-center
        w-12 h-12 bg-[#2a2a2a] rounded-lg
      ">
        <FileText className="w-5 h-5 text-[#666666]" />
        <span className="text-[8px] text-[#666666] mt-0.5 font-medium">
          {getFileExtension(document.original_filename)}
        </span>
      </div>

      {/* File info */}
      <div className="flex-1 min-w-0">
        <h3 className="text-white text-sm font-medium truncate">
          {document.original_filename}
        </h3>
        <p className="text-[#666666] text-xs mt-1">
          {formatFileSize(document.file_size)} • {formatFullDate(document.created_at)}
        </p>
      </div>

      {/* Delete button */}
      <button
        onClick={onDelete}
        className="
          p-1.5 rounded-lg text-[#666666]
          opacity-0 group-hover:opacity-100
          hover:text-red-400 hover:bg-[#333333]
          transition-all
        "
        title="Excluir arquivo"
      >
        <Trash2 className="w-4 h-4" />
      </button>
    </div>
  );
};
